// extracted by mini-css-extract-plugin
module.exports = {"repayButtonBox":"repayButtons_repayButtonBox__lyozz","payCommonButton":"repayButtons_payCommonButton__BG289","payError":"repayButtons_payError__w6G_U"};